export const getEstimatedPayments = (specialPrice) => {
  if (specialPrice != null && window.THD && window.THD.PaymentEstimator) {
    const { promotionTerm, monthlyPayment } = window.THD.PaymentEstimator
      .estimatedPayments(specialPrice) || {};
    return {
      promotionTerm,
      monthlyPayment,
    };
  }
  return {};
};

export const getPaymentsEstimatorApplynowLinks = (page) => {
  if (page && window.THD && window.THD.PaymentEstimator) {
    const { desktopUrl, mobileUrl } = window.THD.PaymentEstimator
      .paymentEstimatorApplynowLinks(page) || {};
    return {
      desktopUrl,
      mobileUrl,
    };
  }
  return {};
};

export const getToolTipText = () => {
  if (window.THD && window.THD.PaymentEstimator) {
    window.THD.PaymentEstimator.toolTipText();
  }
  return '';
};
